import BaseListener from "./baseListener";
import { TrackEvent } from "./baseListener";
class ButtonClickListener extends BaseListener {
  private observer: any = null;

  constructor() {
    super();
    this.createObserver();
  }

  private createObserver() {
    this.observer = new MutationObserver((mutations: any) => {
      mutations.forEach((mutation: any) => {
        // 只处理当前容器内的变化
        if (!mutation.target.isConnected) return;
        (mutation.target as HTMLElement).querySelectorAll('a,button,.winitd-dropdown-menu-title-content,.winitd-tree-treenode-switcher-close')
          .forEach((el) => {
            const htmlEl = el as HTMLElement;
            if (!htmlEl.dataset?.trackerBound) {
              htmlEl.dataset.trackerBound = 'true';
              htmlEl.addEventListener('click', () => this.handleClick(htmlEl));
            }
          });
      });
    });
  }

  private handleClick = (el: HTMLElement) => {
    let fieldKey = el.getAttribute?.('id') || '',
      fieldLabel = el.getAttribute?.('aria-label') || '',
      nodeDesc = el.innerText?.trim() || el.getAttribute?.('title') || '',
      nodeName = el.nodeName,
      fieldVal = '';
    // 文件上传控件中的删除按钮
    const formItem = el.closest('.winitd-form-item');
    if (formItem && !fieldKey) {
      const labelElement = formItem.querySelector<HTMLElement>('.winitd-form-item-label label');
      fieldKey = labelElement?.getAttribute('for') || '';
    }
    //自定义的扩展数据
    let ext = {};
    if (el.getAttribute('data-monitor-ext') || el.querySelector('[data-monitor-ext]')?.getAttribute('data-monitor-ext')) {
      try {
        ext = JSON.parse(el.getAttribute('data-monitor-ext')
          || el.querySelector('[data-monitor-ext]')?.getAttribute('data-monitor-ext') || '{}');
      } catch (e) {
        console.error(`解析自定义扩展数据失败: ${el.getAttribute('data-monitor-ext')}`, e);
      }
    }
    // 树形空间的多选框是个span，用点击事件监听
    if (el.classList.contains('winitd-tree-treenode-switcher-close') && el.querySelector('.winitd-tree-checkbox')) {
      nodeName = 'CHECKBOX';
      fieldVal = el?.classList?.contains('winitd-tree-treenode-checkbox-checked') ? 'Y' : 'N';
      nodeDesc = (el?.querySelector('.winitd-tree-title') as HTMLElement)?.innerText?.trim();
    }
    if (fieldKey || fieldLabel || nodeDesc) {
      this.config.onEmit({
        nodeType: 'click',
        nodeName,
        nodeDesc,
        fieldKey,
        fieldLabel,
        fieldVal,
        timestamp: Date.now(),
        ext
      },el);
    }
  };

  start(onEmit: (event: TrackEvent, el?: HTMLElement) => void, container: HTMLElement) {
    this.config = {
      onEmit: onEmit,
      container: container,
    };
    this.observer.observe(this.config.container, {
      childList: true,
      subtree: true
    });
  };


  stop() {
    this.config.container.querySelectorAll('[data-tracker-bound="true"]').forEach((el:any) => {
      el.removeEventListener('click', () => this.handleClick(el));
    });
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

export default ButtonClickListener;
